




import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class Picture extends Vue {
  @Prop(String) readonly src?: string;
  @Prop({ default: 'Image' }) readonly alt?: string;
  @Prop({ default: '16px' }) readonly width?: string;
  @Prop({ default: '16px' }) readonly height?: string;
  @Prop({ default: 'initial' }) readonly maxWidth?: string;
  @Prop(String) readonly padding?: string;
  @Prop(String) readonly margin?: string;
  @Prop({ default: false }) readonly rounded?: boolean;

  get style() {
    return `
      width: ${this.width};
      max-width: ${this.maxWidth};
      height: ${this.height};
      ${this.padding ? `padding: ${this.padding};` : ''}
      ${this.margin ? `margin: ${this.margin};` : ''}
      ${this.rounded ? 'border-radius: 50%;' : ''}
    `;
  }

  @Emit('click')
  click() {}
}
